<template>

<div class="form" v-if="layout && layout.length">

	<template v-for="item in layout">

		<com-input v-if="item.type === $constants.layout.type.input" :key="item.id" :input="inputs[item.inputs[0]]" />
		<com-group v-if="item.type === $constants.layout.type.group" :key="item.id" :item="item" />
		<com-grid v-if="item.type === $constants.layout.type.grid" :key="item.id" :item="item" />
		<com-text v-if="item.type === $constants.layout.type.text" :key="item.id" :item="item" />

	</template>

</div>

</template>

<script>

import comInput from './form/Input'
import comGrid from './form/Grid'
import comGroup from './form/Group'
import comText from './form/Text'

export default {

	props: ['section'],

	components: {
		'com-input': comInput,
		'com-grid': comGrid,
		'com-group': comGroup,
		'com-text': comText
	},

	computed: {

		layout: function() {

			return this.section.layout

		}

	}

}

</script>

<style scoped>

.form {
	flex-grow: 1;
}

</style>